import React, { useState, useMemo } from "react";
import dayjs from "dayjs";

// Assets
import EmptyState from "assets/empty-state.png";
import InfoBlack from "assets/info-black.png";

// Components
import ModalLeadDetail from "../modal-lead-detail";

import {
  useLeadsManagementMethod,
  useLeadsManagementState,
} from "../useLeadsManagementContext";

const widthContainer = 1167;

const PrimarySize = {
  no: 32,
  id: 32,
  project: 180,
  customerName: 132,
  whatsapp: 110,
  domisili: 120,
  marketing: 104,
  waktuLeads: 130,
  status: 106,
};

// Class
const headerRowClassName =
  "flex items-center px-4 py-2 gap-[24px] bg-[#FaFaFa] border-b-[1px] border-solid border-[#D8D8D9]";
const headerColClassName =
  "text-[13px]/[21px] tracking-[-0.4px] font-inter text-[#808285]";

const bodyRowClassName =
  "flex items-center px-4 py-[10px] gap-[24px] border-b-[0.5px] border-solid border-[#D8D8D9]";
const bodyColClassName =
  "text-[13px]/[21px] tracking-[-0.4px] font-inter text-[#252526] truncate";

const TablePrimary = ({ data }) => {
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { params, totalData } = useLeadsManagementState();
  const { handleNextPage, handlePrevPage } = useLeadsManagementMethod();

  const _getSize = (size) => {
    return `${(size / widthContainer) * 100}%`;
  };

  const handleOpenModal = (leadId) => {
    setSelectedLeadId(leadId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLeadId(null);
  };

  const LIST_LEADS_PRIMARY = useMemo(() => {
    if (!data?.length) return [];

    return data.map((leads, index) => {
      return {
        no: index + 1,
        id: leads?.id,
        project: leads?.project_name ?? "",
        namaCustomer: leads?.name ?? "",
        whatsapp: leads?.phone_number ?? "",
        domisili: leads?.lead_location ?? "",
        marketing: leads?.name ?? "",
        waktuLeads: dayjs(leads?.timestamps_leads).format(
          "DD/MM/YYYY; HH:mm WIB"
        ),
        skor: leads?.score ? `${leads?.score}` : "-",
        visitSchedules: leads?.visit_schedule,
      };
    });
  }, [data]);

  return (
    <>
      <div className="rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9] min-w-[1167px]">
        {/* Header */}
        <div className={headerRowClassName}>
          <div
            className={headerColClassName}
            style={{ width: _getSize(PrimarySize.no), fontSize: "13px" }}
          >
            No.
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.id) }}
          >
            ID
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.project) }}
          >
            Project
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.customerName) }}
          >
            Nama Customer
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.whatsapp) }}
          >
            No WhatsApp
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.domisili) }}
          >
            Domisili
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.marketing) }}
          >
            Marketing
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.waktuLeads) }}
          >
            Waktu Leads
          </div>
          <div
            className={headerColClassName}
            style={{ fontSize: "13px", width: _getSize(PrimarySize.status) }}
          >
            Skor
          </div>
        </div>

        {/* Body */}
        {LIST_LEADS_PRIMARY?.length ? (
          LIST_LEADS_PRIMARY.map((item, index) => (
            <div key={`table-primary-${item.id}`} className={bodyRowClassName}>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.no) }}
              >
                {index + 1}
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.id) }}
              >
                #{item.id}
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.project) }}
              >
                <span
                  style={{
                    fontSize: "11px",
                    color: "#252526",
                    fontWeight: "600",
                  }}
                  className="rounded-[4px] bg-[#E6E7E8] px-2 py-0.5"
                >
                  {item.project}
                </span>
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.customerName) }}
              >
                <span>{item.namaCustomer}</span>
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.whatsapp) }}
              >
                <span>{item.whatsapp}</span>
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.domisili) }}
              >
                <span>{item.domisili}</span>
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.marketing) }}
              >
                <span>{item.marketing}</span>
              </div>
              <div
                className={bodyColClassName}
                style={{ width: _getSize(PrimarySize.waktuLeads) }}
              >
                <span>{item.waktuLeads}</span>
              </div>
              <div
                className={`${bodyColClassName} flex items-center gap-2 justify-between`}
                style={{ width: _getSize(PrimarySize.status) }}
              >
                <p>
                  {item.skor}
                  <span className="!text-[#808285]">/100</span>
                </p>
                <button
                  className="w-6 h-6 border border-solid border-[#D8D8D9] rounded-[4px] flex items-center justify-center"
                  onClick={() => handleOpenModal(item.id)}
                >
                  <img src={InfoBlack} alt="info-black" className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center gap-2">
            <img
              className="w-[32px] h-[32px] object-contain"
              src={EmptyState}
              alt="empty-state"
            />
            <p className="text-[17px]/[27.5px] tracking-[-0.4px] font-semibold font-inter text-[#D8D8D9]">
              Belum ada leads
            </p>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between mt-4 min-w-[1167px]">
        <p className="text-[11px]/[18px] font-inter text-[#808285]">
          *Menampilkan <span className="text-[#252526]">{LIST_LEADS_PRIMARY.length}</span> dari {totalData} leads yang belum ditanggapi.
        </p>

        <div className="flex items-center gap-2">
          <button onClick={handlePrevPage} className="rotate-180 w-6 h-6 border border-solid border-[#D8D8D9] rounded-[4px] flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M9.93453 7.30977L5.55953 11.6848C5.51888 11.7254 5.47063 11.7577 5.41752 11.7797C5.36441 11.8017 5.30748 11.813 5.25 11.813C5.19251 11.813 5.13559 11.8017 5.08248 11.7797C5.02937 11.7577 4.98112 11.7254 4.94047 11.6848C4.89982 11.6441 4.86758 11.5959 4.84558 11.5428C4.82358 11.4897 4.81226 11.4327 4.81226 11.3752C4.81226 11.3178 4.82358 11.2608 4.84558 11.2077C4.86758 11.1546 4.89982 11.1064 4.94047 11.0657L9.00648 7.00024L4.94047 2.93477C4.85837 2.85268 4.81226 2.74134 4.81226 2.62524C4.81226 2.50915 4.85837 2.3978 4.94047 2.31571C5.02256 2.23362 5.1339 2.1875 5.25 2.1875C5.3661 2.1875 5.47744 2.23362 5.55953 2.31571L9.93453 6.69071C9.97521 6.73134 10.0075 6.7796 10.0295 6.83271C10.0515 6.88582 10.0628 6.94275 10.0628 7.00024C10.0628 7.05774 10.0515 7.11467 10.0295 7.16778C10.0075 7.22089 9.97521 7.26914 9.93453 7.30977Z"
                fill={params.page === 0 ? "#252526" : "#D8D8D9"}
              />
            </svg>
          </button>
          <span className="text-[11px]/[18px] font-semibold font-inter text-[#252526] w-6 h-6 rounded-[4px] flex items-center justify-center shadow-[0_0_2px_0_rgba(0,0,0,0.32)]">{params.page}</span>
          <button onClick={handleNextPage} className="w-6 h-6 border border-solid border-[#D8D8D9] rounded-[4px] flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M9.93453 7.30977L5.55953 11.6848C5.51888 11.7254 5.47063 11.7577 5.41752 11.7797C5.36441 11.8017 5.30748 11.813 5.25 11.813C5.19251 11.813 5.13559 11.8017 5.08248 11.7797C5.02937 11.7577 4.98112 11.7254 4.94047 11.6848C4.89982 11.6441 4.86758 11.5959 4.84558 11.5428C4.82358 11.4897 4.81226 11.4327 4.81226 11.3752C4.81226 11.3178 4.82358 11.2608 4.84558 11.2077C4.86758 11.1546 4.89982 11.1064 4.94047 11.0657L9.00648 7.00024L4.94047 2.93477C4.85837 2.85268 4.81226 2.74134 4.81226 2.62524C4.81226 2.50915 4.85837 2.3978 4.94047 2.31571C5.02256 2.23362 5.1339 2.1875 5.25 2.1875C5.3661 2.1875 5.47744 2.23362 5.55953 2.31571L9.93453 6.69071C9.97521 6.73134 10.0075 6.7796 10.0295 6.83271C10.0515 6.88582 10.0628 6.94275 10.0628 7.00024C10.0628 7.05774 10.0515 7.11467 10.0295 7.16778C10.0075 7.22089 9.97521 7.26914 9.93453 7.30977Z"
                fill={LIST_LEADS_PRIMARY.length > 1 ? "#252526" : "#D8D8D9"}
              />
            </svg>
          </button>
        </div>
      </div>

      <ModalLeadDetail
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        leadId={selectedLeadId}
      />
    </>
  );
};

export default TablePrimary;
